// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1fBLU","file":"styles_file__2N2i0"};